export default __webpack_public_path__ + "static/media/36I-102703_-15683_0.b2994ccb.jpg";